import { render } from "./LocalGithubActivity.vue?vue&type=template&id=5cb269f1&scoped=true&ts=true"
import script from "./LocalGithubActivity.vue?vue&type=script&lang=ts"
export * from "./LocalGithubActivity.vue?vue&type=script&lang=ts"

import "./LocalGithubActivity.vue?vue&type=style&index=0&id=5cb269f1&scoped=true&lang=css"
import "./LocalGithubActivity.vue?vue&type=style&index=1&id=5cb269f1&lang=css"

import exportComponent from "/home/bwhite/Projects/bryanchriswhite-com/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cb269f1"]])

export default __exports__